import React from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';

export const LocationFormDialog = ({ open, onOpenChange, editingLocation, locationForm, setLocationForm, onSave, saving }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>{editingLocation ? 'Edit Location' : 'Add Delivery Location'}</DialogTitle>
        <DialogDescription className="sr-only"> dialog. Use the form below to continue.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <Label>Location Name *</Label>
          <Input
            value={locationForm.name}
            onChange={(e) => setLocationForm({ ...locationForm, name: e.target.value })}
            placeholder="e.g., Main Store, Warehouse"
          />
        </div>
        <div>
          <Label>Street Address *</Label>
          <Input
            value={locationForm.address}
            onChange={(e) => setLocationForm({ ...locationForm, address: e.target.value })}
            placeholder="123 Main St"
          />
        </div>
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1">
            <Label>City *</Label>
            <Input
              value={locationForm.city}
              onChange={(e) => setLocationForm({ ...locationForm, city: e.target.value })}
              placeholder="City"
            />
          </div>
          <div>
            <Label>State *</Label>
            <Input
              value={locationForm.state}
              onChange={(e) => setLocationForm({ ...locationForm, state: e.target.value })}
              placeholder="CA"
              maxLength={2}
            />
          </div>
          <div>
            <Label>ZIP *</Label>
            <Input
              value={locationForm.zip_code}
              onChange={(e) => setLocationForm({ ...locationForm, zip_code: e.target.value })}
              placeholder="90210"
            />
          </div>
        </div>
        <div>
          <Label>Receiving Hours</Label>
          <Input
            value={locationForm.receiving_hours}
            onChange={(e) => setLocationForm({ ...locationForm, receiving_hours: e.target.value })}
            placeholder="e.g., Mon-Fri 6AM-2PM"
          />
        </div>
        <div>
          <Label>Delivery Instructions</Label>
          <Input
            value={locationForm.delivery_instructions}
            onChange={(e) => setLocationForm({ ...locationForm, delivery_instructions: e.target.value })}
            placeholder="e.g., Use back entrance, ask for manager"
          />
        </div>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={locationForm.is_default}
            onChange={(e) => setLocationForm({ ...locationForm, is_default: e.target.checked })}
            className="rounded border-gray-300 text-amber-500 focus:ring-amber-500"
          />
          <span className="text-sm">Set as default delivery location</span>
        </label>
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={onSave}
          disabled={saving}
          className="bg-amber-500 hover:bg-amber-600"
        >
          {(() => {
            if (saving) return 'Saving...';
            if (editingLocation) return 'Update';
            return 'Add Location';
          })()}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
